import _InputAdornment from './input-adornment';
import withInstall from '../utils/withInstall';

import './style';

export * from './type';

export const InputAdornment = withInstall(_InputAdornment);

export default InputAdornment;
